// ----------------------------------------------------------------------

export default function Button(theme: any) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            boxShadow: 'none'
          }
        },
        sizeLarge: {
          height: 48
        },
        // contained
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400]
          }
        },
        containedPrimary: {
          boxShadow: theme.customShadows.primary
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary
        },
        containedInfo: {
          boxShadow: theme.customShadows.info
        },
        containedSuccess: {
          boxShadow: theme.customShadows.success
        },
        containedWarning: {
          boxShadow: theme.customShadows.warning
        },
        containedError: {
          boxShadow: theme.customShadows.error
        },
        // outlined
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        }
      },
      // Add custom variants here
      variants: [
        {
          props: { variant: 'alternate' },
          style: {
            background: theme.palette.darkBlue,
            boxShadow: theme.customShadows.z8,
            color: theme.palette.common.white, // Add text color
            '&:hover': {
              backgroundColor: theme.palette.primary.main
            },
            '&:disabled': {
              backgroundColor: theme.palette.grey[400],
              color: theme.palette.grey[600],
              border : 0,
              boxShadow: 'none',
              opacity: 0.6
            }
          }
        },
        {
          props: { variant: 'outlined-alternate' },
          style: {
            boxShadow: theme.customShadows.z8,
            color: theme.palette.darkBlue, // Add text color
            '&:disabled': {
              backgroundColor: theme.palette.grey[400],
              color: theme.palette.grey[600],
              boxShadow: 'none',
              opacity: 0.6
            },
            border: `1px solid ${theme.palette.darkBlue}`,
            '&:hover': {
              backgroundColor: theme.palette.darkBlue,
              color: theme.palette.common.white,
            }
          }
        }
      ]
    }
  };
}